export default "__VITE_ASSET__BvAMhOME__"